/* 
 * 接口统一集成模块
 */

// system
// import * as test from './api/test'
import * as record from './api/record';
import * as review from './api/review';
import * as achievement from './api/achievement';
import * as user from './api/user';

// 默认全部导出
export default {
	// system
	// test,
	record,
	review,
	achievement,
	user,
}


// WEBPACK FOOTER //
// ./src/provider/api.js